import React from 'react';

import { createSkeletonCollection } from 'utils';

import styles from './MaxiSkeleton.module.scss';

const SKELETON_ITEMS_NUMBER = 3;
const SCAFFOLD_SKELETON_ITEMS_PREFIX = 'scaffold-skeleton';

function MaxiSkeleton() {
  const scaffolds = createSkeletonCollection(SKELETON_ITEMS_NUMBER, SCAFFOLD_SKELETON_ITEMS_PREFIX);

  return (
    <div className={styles.scaffold}>
      {scaffolds.map((scaffold) => (
        <div key={scaffold.id} className={styles.scaffoldItem} />
      ))}
    </div>
  );
}
export default MaxiSkeleton;
